import { useState, useRef, useEffect } from 'react';

export const useAudioPlayer = () => {
  const audioRef = useRef(null);
  const [audioFile, setAudioFile] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [playbackSpeed, setPlaybackSpeed] = useState(1.0);

  const loadAudio = (file) => {
    if (!file) {
      setAudioFile(null);
      setIsPlaying(false);
      setCurrentTime(0);
      setDuration(0);
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = "";
      }
      return;
    }
    const url = URL.createObjectURL(file);
    setAudioFile({ name: file.name, url });
    
    // Load saved position
    const savedPositions = JSON.parse(localStorage.getItem('audioPositions') || '{}');
    const savedTime = savedPositions[file.name] || 0;
    
    if (audioRef.current) {
      audioRef.current.src = url;
      audioRef.current.currentTime = savedTime;
      audioRef.current.playbackRate = playbackSpeed;
    }
  };

  const togglePlayPause = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const skip = (seconds) => {
    if (!audioRef.current) return;
    audioRef.current.currentTime = Math.max(0, Math.min(duration, audioRef.current.currentTime + seconds));
  };

  const seekTo = (time) => {
    if (!audioRef.current) return;
    audioRef.current.currentTime = Math.max(0, Math.min(duration, time));
  };

  const setSpeed = (speed) => {
    const newSpeed = Math.max(0.5, Math.min(2.0, speed));
    setPlaybackSpeed(newSpeed);
    if (audioRef.current) {
      audioRef.current.playbackRate = newSpeed;
    }
  };

  const handleTimeUpdate = () => {
    if (!audioRef.current) return;
    setCurrentTime(audioRef.current.currentTime);
    
    if (audioFile?.name) {
      const savedPositions = JSON.parse(localStorage.getItem('audioPositions') || '{}');
      savedPositions[audioFile.name] = audioRef.current.currentTime;
      localStorage.setItem('audioPositions', JSON.stringify(savedPositions));
    }
  };

  const handleLoadedMetadata = () => {
    if (!audioRef.current) return;
    setDuration(audioRef.current.duration);
  };

  return {
    audioRef,
    audioFile,
    isPlaying,
    currentTime,
    duration,
    playbackSpeed,
    loadAudio,
    togglePlayPause,
    skip,
    seekTo,
    setSpeed,
    handleTimeUpdate,
    handleLoadedMetadata
  };
};

